export type Middleware<T = unknown> = (this: { complete(): void }, context: T) => unknown;

export class MiddlewareChain<T = unknown> {
    private chain = new Set<Middleware<T>>();

    public push(middleware: Middleware<T>) {
        this.chain.add(middleware);
    }

    public async run(context?: T) {
        let forward;
        for (const middleware of this.chain) {
            forward = true;
            await middleware.apply(
                {
                    complete: () => {
                        forward = false;
                    },
                },
                context ? [context] : [undefined as any],
            );

            if (!forward) {
                break;
            }
        }
    }
}

export function createMiddlewareChainFacade<T = unknown>() {
    const chain = new MiddlewareChain<T>();

    const facade = (middleware: Middleware<T>) => {
        chain.push(middleware);
    };

    facade.run = (context: T) => chain.run(context);

    return facade;
}
